import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import { orderBy } from 'natural-orderby';

import styled from 'styled-components';

import { Box, Heading, Text } from 'grommet';

import Markup from 'app/api/markup';
import BookElement from 'app/api/bookElement';
import SectionBreak from 'app/components/BookElements/SectionBreak';
import TableOfContentsEntry from 'app/components/BookElements/TableOfContentsEntry';
import Paragraph from 'app/components/Paragraph';

function sortEntries(entries) {
  return _.chain(entries)
    .toPairs()
    .thru(entries =>
      orderBy(entries, [entry => entry[0].toUpperCase()], ['asc'])
    )
    .fromPairs()
    .value();
}

const Source = styled(Text)`
  min-width: 50px;
`;

class Sources extends React.Component {
  render() {
    const { path, content } = this.props;
    if (BookElement.isNotSelected(path)) return null;
    const { details, ...sources } = content;
    return (
      <React.Fragment>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Source Notes
          </Heading>
        </TableOfContentsEntry>
        {details && <Paragraph size="small">{details}</Paragraph>}
        {_.map(sortEntries(sources), (note, source) => (
          <Box key={source} direction="row" gap="small" margin="small">
            <Source weight="bold">{source}</Source>
            <Paragraph margin="none" pad="none" size="small">{Markup.parse(note)}</Paragraph>
          </Box>
        ))}

        <SectionBreak />
      </React.Fragment>
    );
  }
}

Sources.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * source notes entries
   */
  content: PropTypes.object,
};
Sources.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Sources));
Component.displayName = 'Sources';
export const SourcesComponent = Sources;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Sources.js